import React from 'react';
import PropTypes from 'prop-types';
import autoBind from 'react-autobind';
import { InfoWindow } from 'react-google-maps';
import MarkerWithLabel from 'react-google-maps/lib/components/addons/MarkerWithLabel';
import { arrayToBounds, arrayToPoint } from '../../../lib/google-maps';
import ImageOverlay from '../../../components/ImageOverlay';
import Infographic from '../../../components/Infographic';

class MapEditMarker extends React.Component {
  constructor(props) {
    super(props);
    autoBind(this);
    this.state = {
      infoWindowOpen: this.props.open || false,
      labelOpen: false,
      infographics: []
    };
  }

  async componentDidMount() {
    await this.fetchInfographics();
  }

  async componentDidUpdate(prevProps, prevState, snapshot) {
    let { marker: prevMarker } = prevProps;
    if (prevMarker && prevMarker._id !== this.props.marker._id) {
      this.setState({ infoWindowOpen: false });
      await this.fetchInfographics();
    }
  }

  async fetchInfographics() {
    let infographics = await this.props.marker.infographics();
    this.setState({ infographics });
  }

  handleMarkerClose() {
    this.setState({ infoWindowOpen: false });
  }

  handleMarkerToggle() {
    let { infographics } = this.state;
    if (infographics.length) {
      this.setState({
        infoWindowOpen: !this.state.infoWindowOpen
      });
    }
  }

  onMouseOver() {
    if (this.props.marker.name) {
      this.setState({ labelOpen: true });
    }
  }

  onMouseOut() {
    this.setState({ labelOpen: false });
  }

  handleMarkerLocationChange({ latLng }) {
    const { lng, lat } = latLng;
    this.props.onMarkerLocationChange([lng(), lat()]);
  }

  render() {
    const { marker, floor } = this.props;
    const { infoWindowOpen, labelOpen, infographics } = this.state;
    const labelStyle = Object.assign({}, style.label, {
      display: labelOpen ? 'block' : 'none'
    });
    const position = arrayToPoint(marker.geo.coordinates);
    const latLngBounds = arrayToBounds(floor.geo.coordinates);
    const markerImage = marker.type_id ? marker.type().image.path : null;
    return (
      <div>
        <ImageOverlay
          heading={floor.overlay.heading}
          opacity={floor.overlay.opacity}
          image={floor.overlay.image.path}
          bounds={latLngBounds}
          map={window.MP_MAPEDIT_REF}
        />
        <MarkerWithLabel
          position={position}
          cursor={infographics.length ? 'pointer' : 'default'}
          onClick={this.handleMarkerToggle}
          onMouseOver={this.onMouseOver}
          onMouseOut={this.onMouseOut}
          draggable
          onDragEnd={this.handleMarkerLocationChange}
          icon={markerImage}
          labelAnchor={new window.google.maps.Point(0, 0)}
        >
          <div style={labelStyle}>{marker.name}</div>
        </MarkerWithLabel>
        {infoWindowOpen && (
          <InfoWindow
            onCloseClick={this.handleMarkerClose}
            position={position}
            options={{ pixelOffset: new window.google.maps.Size(0, -41) }}
          >
            <div>
              {infographics.map(infographic => (
                <Infographic infographic={infographic} key={infographic._id} />
              ))}
            </div>
          </InfoWindow>
        )}
      </div>
    );
  }
}

MapEditMarker.propTypes = {
  marker: PropTypes.object.isRequired,
  open: PropTypes.bool
};

const style = {
  label: {
    padding: 7.5,
    backgroundColor: '#fff',
    borderRadius: 2,
    fontSize: 12
  }
};

export default MapEditMarker;



// WEBPACK FOOTER //
// ./src/pages/Facility/MapEditMarker/index.jsx